module.exports = __webpack_public_path__ + "static/media/Group 27.edf53d40.svg";